module.exports = __webpack_public_path__ + "img/06.60d65df7.jpg";